// extracted by mini-css-extract-plugin
export var fadeInOut = "_3k-3";
export var icon = "_3k-4";
export var savedIndicator = "_3k-2";
export var savingIndicator = "_3k-0";
export var spin = "_3k-1";